import { CSSProperties, SVGProps } from 'react';

interface ICopyIconProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
}

export const CopyIcon = ({ color, ...props }: ICopyIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.73987 13.4497C1.5 13.0051 1.5 12.4168 1.5 11.24V8.5C1.5 7.56812 1.5 7.10218 1.65224 6.73463C1.85523 6.24458 2.24458 5.85523 2.73463 5.65224C3.10218 5.5 3.56812 5.5 4.5 5.5V7.425C4.5 8.89596 4.5 9.63144 4.79984 10.1871C5.03146 10.6164 5.38359 10.9685 5.81286 11.2002C6.36856 11.5 7.10404 11.5 8.575 11.5H10.5C10.5 12.4319 10.5 12.8978 10.3478 13.2654C10.1448 13.7554 9.75542 14.1448 9.26537 14.3478C8.89782 14.5 8.43188 14.5 7.5 14.5H4.76C3.58323 14.5 2.99485 14.5 2.55029 14.2601C2.20688 14.0748 1.92517 13.7931 1.73987 13.4497ZM5.73987 9.44971C5.5 9.00515 5.5 8.41677 5.5 7.24V4.76C5.5 3.58323 5.5 2.99485 5.73987 2.55029C5.92517 2.20687 6.20687 1.92517 6.55029 1.73987C6.99485 1.5 7.58323 1.5 8.76 1.5H11.24C12.4168 1.5 13.0051 1.5 13.4497 1.73987C13.7931 1.92517 14.0748 2.20687 14.2601 2.55029C14.5 2.99485 14.5 3.58323 14.5 4.76V7.24C14.5 8.41677 14.5 9.00515 14.2601 9.44971C14.0748 9.79313 13.7931 10.0748 13.4497 10.2601C13.0051 10.5 12.4168 10.5 11.24 10.5H8.76C7.58323 10.5 6.99485 10.5 6.55029 10.2601C6.20687 10.0748 5.92517 9.79313 5.73987 9.44971Z"
        fill={color}
      />
    </svg>
  );
};
